import React from 'react';

import Popup from '../../Popup';

import styles from './welcomePopUps.scss';
import utrRangeStyles from '../../Profile/RatingDisplayV2/ratingDisplayV2.scss';

const UtrRangePopup = (props) => {
    const {
        onCloseClick,
        rating,
    } = props;

    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
            data-testid="modal.utr-range"
        >
            <div className={`${styles.section} ${utrRangeStyles.ratingDisplay} text-center pt16 pb8`}>
                <div className={utrRangeStyles.utrRange}>
                    <div className={utrRangeStyles.utr} data-testid="modal.utr-range.rating-value">{rating?.utrRange?.minUtr?.toFixed(2)} - {rating?.utrRange?.maxUtr?.toFixed(2)}</div>
                    <div className={utrRangeStyles.description} data-testid="modal.utr-range.rating-label">Estimated UTR Rating</div>
                </div>
            </div>
            <div className={`${styles.section} text-center pt16`}>
                <div className={`mb24`}>
                    <p className="text-dark" data-testid="modal.utr-range.description">
                        This is your approximate UTR Rating range based on the playing experience you have. As you play and scores are posted, your UTR Rating will become more accurate.
                    </p>
                </div>
                <div className="mt48">
                    <button
                        type="button"
                        className="btn btn-primary btn-xl btn-block text-uppercase"
                        onClick={onCloseClick}
                        data-testid="modal.utr-range.ok-btn"
                    >
                        OK
                    </button>
                </div>
            </div>
        </Popup>
    );
};

export default UtrRangePopup;
